import { useContext } from 'react';
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { FiltersContext } from '../store/filters-options-context';
import SearchIndicator from './SearchBulk';
import BulkSummary from './BulkRecap';

export default function BulkFilters() {
    const { params } = useContext(FiltersContext);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const firstYear = params.year[0];
    const lastYear = params.year.slice(-1).pop();


    return (
        <Box>
            {!isMobile &&
                <>
                    <SearchIndicator isMobile={isMobile} />
                    <BulkSummary isMobile={isMobile} firstYear={firstYear} lastYear={lastYear} />
                </>
            }
        </Box>
    )
}